import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Logo = props => {
  useEffect(() => {
    window.location.pathname === '/' && document.querySelector('#logo-app').setAttribute('aria-level', '1')

    return () => {
      document.querySelector('#logo-app').removeAttribute('aria-level')
    }
  })

  return (
    <Fragment>
      <div className='logo zindex col-3 col-sm-1 mx-auto mx-md-0 pr-sm-0 h-100'>
        <div className='row align-items-center h-100'>
          <Link
            id='logo-app'
            to={window.location.pathname !== '/' ? '/' : '#'}
            className='d-block pos-absolute w-100 logo-header-link logo-header logo-header-img my-1'
            aria-label={`Logo ${process.env.REACT_APP_TITLE || 'Web Prêmios'}`}
            role={window.location.pathname !== '/' ? 'link' : 'heading'}
          >
            <span aria-hidden='true'>{`Logo ${process.env.REACT_APP_TITLE || 'Web Prêmios'}`}</span>
          </Link>
        </div>
      </div>
    </Fragment>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/App/Header/Logo/Logo.js